<template>
  <a-row class="login-page" type="flex" justify="center" align="middle">
    <transition appear appear-active-class="animated jackInTheBox">
      <a-col class="box">
        <transition appear appear-active-class="animated fadeInDown faster delay-1s">
          <a-row class="head" type="flex" align="middle" justify="center">
            <a-col>
              <h1>Lucas罗高仕 O2O管理平台</h1>
            </a-col>
          </a-row>
        </transition>
        <a-form :form="form" @submit.prevent="handleSubmit" class="form-body">
          <a-row type="flex" justify="center">
            <a-col span="18">
              <a-form-item>
                <a-input
                  size="large"
                  placeholder="邮箱"
                  v-decorator="[
                    'email',
                    {
                      rules: [
                        { required: true, message: '请输入邮箱' },
                        { type: 'email', message: '请输入正确的邮箱' }
                      ]
                    }
                  ]"
                >
                  <a-icon type="mail" slot="addonBefore" style="font-size:18px;margin:0 5px" />
                </a-input>
              </a-form-item>
            </a-col>
            <a-col span="18">
              <a-form-item>
                <a-input
                  size="large"
                  type="password"
                  placeholder="密码"
                  v-decorator="[
                    'pass',
                    { rules: [{ required: true, message: '请输入密码' }] }
                  ]"
                >
                  <a-icon type="lock" slot="addonBefore" style="font-size:18px;margin:0 5px" />
                </a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row type="flex" align="middle" justify="center">
            <a-col span="18">
              <a-button
                block
                type="primary"
                size="large"
                style="padding:0 40px"
                htmlType="submit"
                :loading="loading"
              >登录</a-button>
            </a-col>
            <a-col
              span="24"
              style="text-align:center;color:#999;font-size:12px;padding-top:14px;"
            >忘记密码，请联系管理员</a-col>
            <a-col
              span="24"
              style="text-align:center;color:#999;font-size:12px;padding-top:14px;"
            >当前IP地址：{{ addr || "未知" }}</a-col>
          </a-row>
        </a-form>
      </a-col>
    </transition>
  </a-row>
</template>
<script>
import { mapActions } from "vuex";
import Api from "@/api";
import { encryptString } from "@/shared/utils/secureStorage";
export default {
  name: "Login",
  data() {
    return {
      loading: false,
      addr: ""
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  async created() {
    let { ip } = await Api.common.getIPaddr();
    this.addr = ip;
  },
  methods: {
    ...mapActions(["login"]),
    handleSubmit() {
      this.form.validateFields(async (err, value) => {
        if (!err) {
          this.loading = true;
          try {
            // 加密密码后传参给接口
            const encryptedValue = {
              ...value,
              pass: encryptString(value.pass)
            };
            await this.login(encryptedValue);
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          } catch (e) {}
          this.loading = false;
        }
      });
    }
  }
};
</script>
<style lang="scss">
.login-page {
  height: 100vh;
  padding-bottom: 150px;
  background: url(../../assets/login_bg.jpg) 0 0 / cover;
  .box {
    width: 500px;
    border-radius: 8px;
    overflow: hidden;
    .head {
      height: 100px;
      background: rgba(0, 0, 0, 0.2);
      h1 {
        color: #fff;
        margin: 0;
      }
    }
    .form-body {
      padding: 45px 20px 20px;
      background: #fff;
    }
  }
}
</style>
